import { ParsedTelemetry, TelemetryFormat } from "../types"
import { sampleRate } from "./sample-rate"

const TIMESTAMP = "UNIX Time Stamp"
const LATITUDE = "Sensor Latitude"
const LONGITUDE = "Sensor Longitude"
const ALTITUDE = "Sensor True Altitude"
const YAW = "Sensor Relative Azimuth Angle"
const PITCH = "Sensor Relative Elevation Angle"
const ROLL = "Sensor Relative Roll Angle"
const HFOV = "Sensor Horizontal Field of View"
const VFOV = "Sensor Vertical Field of View"

const parse = (text: string): ParsedTelemetry => {
    const lines = text.split("\n").filter((line) => line.trim() !== "")
    const header = lines[0].split(",")
    const column = (name: string) => header.indexOf(name)

    const timestampCol = column(TIMESTAMP)
    const latitudeCol = column(LATITUDE)
    const longitudeCol = column(LONGITUDE)
    const altitudeCol = column(ALTITUDE)
    const yawCol = column(YAW)
    const pitchCol = column(PITCH)
    const rollCol = column(ROLL)
    const hfovCol = column(HFOV)
    const vfovCol = column(VFOV)

    const events = lines.slice(1).map((line) => {
        const columns = line.split(",")
        const value = (col: number) => (col >= 0 ? Number(columns[col]) : NaN)
        return {
            timestamp: value(timestampCol) / 1000,
            latitude: value(latitudeCol),
            longitude: value(longitudeCol),
            height: altitudeCol >= 0 ? Number(columns[altitudeCol]) : NaN,
            elevation: undefined,
            yaw: value(yawCol),
            pitch: value(pitchCol),
            roll: value(rollCol),
            fov: hfovCol >= 0 && vfovCol >= 0 ? [value(hfovCol), value(vfovCol)] : undefined,
        }
    })
    return { events, samplesPerSecond: sampleRate(events.map((event) => event.timestamp)) }
}

export const astro = {
    name: "astro",
    matches: (prefix) => prefix.startsWith("UNIX Time Stamp,"),
    parse,
} satisfies TelemetryFormat
